import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdHome, MdLightMode, MdLocationPin, MdSearch } from "react-icons/md";
import pr1 from '../assets/pr1.jpg';
import pr2 from '../assets/pr2.jpg';
import pr3 from '../assets/pr3.jpg';
import pr4 from '../assets/pr4.jpg';
import pr5 from '../assets/pr5.jpg';
import pr6 from '../assets/pr6.jpg';
import pr7 from '../assets/pr7.jpg';
import pr8 from '../assets/pr8.jpg';
import pr9 from '../assets/pr9.jpg';
import pr10 from '../assets/pr10.jpg';
import pr11 from '../assets/pr11.jpg';
import pr12 from '../assets/pr12.jpg';
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneObjective from "./OneObjective";

// Medical Equipments
import d4 from '../assets/photos/medical_equipments/17.jpg';
import d19 from '../assets/photos/medical_equipments/7.jpg';

// Promotional Materials
import br3 from '../assets/photos/promotional_materials/13.jpg';
import br15 from '../assets/photos/promotional_materials/5.jpg';

// Smart Mobile
import sm2 from '../assets/photos/smart_mobile/1.jpg';
import sm6 from '../assets/photos/smart_mobile/6.jpg';

// Real Estate
import res5 from '../assets/photos/real_estate/5.jpg';
import res18 from '../assets/photos/real_estate/18.jpg';

// Telecom Solutions
import tel1 from '../assets/photos/telecom_solutions/8.jpg';
import tel7 from '../assets/photos/telecom_solutions/3.jpg';

// ICT Solutions
import ict4 from '../assets/photos/ict_solutions/5.jpg';
import ict10 from '../assets/photos/ict_solutions/9.jpg';

// Agricultural Solutions
import ag2 from '../assets/photos/agricultular_solutions/2.jpg';
import ag5 from '../assets/photos/agricultular_solutions/6.jpg';


export default function AboutUsContent(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}


	

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px"
				}}
			>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h6
								className="main-section-title"
							>
								About Us
							</h6>
						</div>

						<div className="col-md-4 text-center mb-3 mt-3">
							<div className="card">
								<div className="card-body">
									<h6
										style={{
											fontSize: "84px",
										}}
										className="font-bold text-primary"
									>
										20+
									</h6>
									<h6
										className="font-bold text-muted"
									>
										YEARS OF EXPERIENCE
									</h6>
								</div>
							</div>
						</div>

						<div className="col-md-8 mt-3 mb-3">
							<h6
								style={{
									fontSize: "28px",
								}}
								className="font-semi-bold text-primary"
							>
								JIEZHI TECH CO LTD is a leading multi-specialty supplier.
							</h6>

							<p
								style={{
									fontSize: "16px"
								}}
							>
								Jiezhi Tech offers end-to end supply chain logistics solutions and helps clients across diverse industries improve customization, performance, and cost-efficiency.
								<br/>
								<br/>
								With a strong understanding of emerging product trends and rich industry experience spanning over 20 years, Jiechi Tech is well-positioned to transform enterprises, optimize procurement processes, and stimulate growth. Our team of experts, located in both mainland China and Hong Kong, is dedicated to supplying innovative and high-quality products at honest prices. We specialize in providing solutions for a wide range of sectors,
							</p>
							
						</div>

						<div className="col-md-12 mt-3 mb-3">
							<HorizontalImageStrip
								images={[d4, d19, br3, br15, sm2, sm6, res5, res18, tel1, tel7, ict4, ict10, ag2, ag5]}
							/>

							<div
								style={{
									padding: "30px",
								}}
								className="bg-surface mt-4 mb-4 text-center mShadow2"
							>
								<h6
									style={{
										fontSize: "32px",
										textTransform: "uppercase"
									}}
									className="text-center font-bold mt-2 mb-2"
								>
									we prioritize delivering high-impact solutions
								</h6>

								<p
									style={{
										fontSize: "16px"
									}}
								>
									At Jiezhi Tech, we prioritize delivering high-impact solutions that incorporate customized functionality tailored to our clients' specific requirements. Our comprehensive experience, through processes, and expansive creative vision enable us to consistently provide innovative, usable, and reliable services and products. As a testament to our commitment to excellence, Jiezhi Tech has met all legal requirements and is certified to provide our diverse range of products and services. 
									<br/><br/>
									We take pride in our ability to help our clients navigate the ever-evolving landscape of technology and logistics, ensuring their success in today's competitive market.
								</p>
							</div>
						</div>

						<div className="col-md-6 bg-primary">
														
							<h6
								style={{
									fontSize: "32px",
									textTransform: "uppercase"
								}}
								className="text-center font-bold mt-5 mb-2"
							>
								OUR VISION
							</h6>

							<h6
								style={{
									fontSize: "16px",
									padding: "20px"
								}}
								className="font-semi-bold"
							>
								Our vision is to be the preferred choice for customers, suppliers, and employees by redefining the standards of customer service and consistently exceeding expectations.
							</h6>
							
						</div>

						<div className="col-md-6 bg-surface">
														
							<h6
								style={{
									fontSize: "32px",
									textTransform: "uppercase"
								}}
								className="text-center font-bold mt-5 mb-2"
							>
								OUR MISSION
							</h6>

							<h6
								style={{
									fontSize: "16px",
									padding: "20px"
								}}
								className="font-semi-bold"
							>
								Our mission is to procure and supply high-quality products at affordable prices, ensuring customer satisfaction. We strive to offer a wide range of products that align with market needs, leveraging technological innovations and continuously developing our team and employee standards. We are dedicated to understanding and addressing customer needs at the highest level by providing flexibility in sourcing, competitive prices, on-time deliveries, and customized solutions for unique requirements.
							</h6>
							
						</div>

						<div className="col-md-12">
														
							<h6
								style={{
									fontSize: "32px",
									textTransform: "uppercase"
								}}
								className="text-center font-bold mt-5 mb-2"
							>
								OUR OBJECTIVES
							</h6>

							<div className="row">
								<div className="col-md-4">
									<OneObjective
										icon={<MdLightMode size={42} className="text-primary"/>}
										content={`To build long-term
											relationships with
											our customers and
											offer the bestfitting solutions to
											cater to their
											needs.`}
									/>
								</div>

								<div className="col-md-4">
									<OneObjective
										icon={<MdLightMode size={42} className="text-primary"/>}
										content={`To offer highquality products
											and services to all
											clients on time
											and support their
											initiatives.`}
									/>
								</div>

								<div className="col-md-4">
									<OneObjective
										icon={<MdLightMode size={42} className="text-primary"/>}
										content={`To acquire new
											clients and let
											them experience
											our innovative
											products and
											services.`}
									/>
								</div>

								<div className="col-md-3">
									<OneObjective
										icon={<MdLightMode size={42} className="text-primary"/>}
										content={`To continue
											investing in
											innovation and
											technology, to
											let our clients
											reap benefits
											out of it.`}
									/>
								</div>

								<div className="col-md-3">
									<OneObjective
										icon={<MdLightMode size={42} className="text-primary"/>}
										content={`To make our
											products and
											services
											available to
											clients at an
											affordable
											price, with no
											compromise in
											quality.`}
									/>
								</div>

								<div className="col-md-3">
									<OneObjective
										icon={<MdLightMode size={42} className="text-primary"/>}
										content={`To provide
											innovative
											products and
											solutions,
											based on latest
											available
											solutions.`}
									/>
								</div>

								<div className="col-md-3">
									<OneObjective
										icon={<MdLightMode size={42} className="text-primary"/>}
										content={`To help
											organizations
											improve
											profitability
											margins
											through crossselling.
											`}
									/>
								</div>

							</div>
							
						</div>

						<div className="col-md-12">
														
							<h6
								style={{
									fontSize: "32px",
									textTransform: "uppercase"
								}}
								className="text-center font-bold mt-5 mb-2"
							>
								OUR CORE VALUES
							</h6>

							<div className="row">
								<div className="col-md-4">
									<OneObjective
										icon={<h6 className="text-primary font-bold" style={{ textTransform: "uppercase", fontSize: "18px" }}>Quality and Affordability</h6>}
										content={`We are committed to meeting customer
											needs by providing high-quality products at
											affordable prices.`}
									/>
								</div>

								<div className="col-md-4">
									<OneObjective
										icon={<h6 className="text-primary font-bold" style={{ textTransform: "uppercase", fontSize: "18px" }}>Customer Satisfaction</h6>}
										content={`We prioritize customer satisfaction by
											leveraging technological innovations and
											delivering exceptional service.`}
									/>
								</div>

								<div className="col-md-4">
									<OneObjective
										icon={<h6 className="text-primary font-bold" style={{ textTransform: "uppercase", fontSize: "18px" }}>Employee Support and Motivation</h6>}
										content={`We foster a supportive and motivating work
											environment for our employees, enabling them
											to become trusted partners for our customers`}
									/>
								</div>

								<div className="col-md-4">
									<OneObjective
										icon={<h6 className="text-primary font-bold" style={{ textTransform: "uppercase", fontSize: "18px" }}>Advanced Solutions</h6>}
										content={`We partner with customers to provide advanced
											solutions that suit their specific needs.`}
									/>
								</div>

								<div className="col-md-4">
									<OneObjective
										icon={<h6 className="text-primary font-bold" style={{ textTransform: "uppercase", fontSize: "18px" }}>Timely Delivery</h6>}
										content={`We ensure the timely delivery of high-quality
											products and services to our clients.`}
									/>
								</div>

								<div className="col-md-4">
									<OneObjective
										icon={<h6 className="text-primary font-bold" style={{ textTransform: "uppercase", fontSize: "18px" }}>Cross-Selling</h6>}
										content={`We aim to cross-sell a wide range of products
											to various organizations and individuals.`}
									/>
								</div>

								<div className="col-md-4">
									<OneObjective
										icon={<h6 className="text-primary font-bold" style={{ textTransform: "uppercase", fontSize: "18px" }}>Innovation</h6>}
										content={`We are dedicated to providing innovative
											products across various industries and investing
											in technology to stay ahead of the curve
											`}
									/>
								</div>

								<div className="col-md-4">
									<OneObjective
										icon={<h6 className="text-primary font-bold" style={{ textTransform: "uppercase", fontSize: "18px" }}>Customer Acquisition</h6>}
										content={`We employ innovative and advanced marketing strategies to acquire new customers adanced and expand
											our client base.
											`}
									/>
								</div>

								<div className="col-md-4">
									<OneObjective
										icon={<h6 className="text-primary font-bold" style={{ textTransform: "uppercase", fontSize: "18px" }}>Reliability</h6>}
										content={`We strive to provide the most reliable and
											affordable products and services to our
											customers.
											`}
									/>
								</div>

							</div>
							
						</div>

						<div className="col-md-12">
							<div
								style={{
									padding: "30px",
								}}
								className="bg-surface mt-4 mb-4 mShadow2"
							>
								<h6
									style={{
										fontSize: "32px",
										textTransform: "uppercase"
									}}
									className="text-center font-bold mt-2 mb-2"
								>
									WHY CHOOSE US
								</h6>

								<h6
									style={{
										fontSize: "18px",
										marginBottom: "30px"
									}}
								>
									<span
										style={{
											fontSize: "24px"
										}}
										className="text-primary font-bold"
									>
										1.Experience
									</span>
									<br/>
									With over 20 years of industry experience, Jiezhi Tech Co., Limited has established itself as a trusted leader in the role as multi-specialty supplier. Our extensive knowledge and expertise ensure that we deliver top-notch results every time.

								</h6>

								<h6
									style={{
										fontSize: "18px",
										marginBottom: "30px"
									}}
								>
									<span
										style={{
											fontSize: "24px"
										}}
										className="text-primary font-bold"
									>
										2.Professional Team
									</span>
									<br/>
									Our team comprises seasoned professionals who are passionate about what they do. From project managers, Quality Control Unit to procurement experts, each member is dedicated to providing unparalleled service and exceeding client expectations with ability to communicate Chinese, English and Swahili Languages.

								</h6>

								<h6
									style={{
										fontSize: "18px",
										marginBottom: "30px"
									}}
								>
									<span
										style={{
											fontSize: "24px"
										}}
										className="text-primary font-bold"
									>
										3.Establishment of Quality Control Lab
									</span>
									<br/>
									We pride ourselves on maintaining the highest standards of quality. To ensure consistency and reliability in our products, we have invested in cutting-edge quality control lab equipped with the latest technology and tools.

								</h6>

								<h6
									style={{
										fontSize: "18px",
										marginBottom: "30px"
									}}
								>
									<span
										style={{
											fontSize: "24px"
										}}
										className="text-primary font-bold"
									>
										4.Cost Control
									</span>
									<br/>
									At Jiezhi Tech Co., Limited, we understand the importance of cost effectiveness. Our streamlined processes and strategic partnerships enable us to offer competitive pricing without compromising on quality service.

								</h6>

								<h6
									style={{
										fontSize: "18px",
										marginBottom: "30px"
									}}
								>
									<span
										style={{
											fontSize: "24px"
										}}
										className="text-primary font-bold"
									>
										5.Innovative Solutions
									</span>
									<br/>
									
									Innovation is at the heart of everything we do. we are constantly exploring new ideas and technologies to stay ahead of the curve and provide our clients with innovative solutions that drive success.
								</h6>

							</div>
						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}